import { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router';

import { start } from '@cartwhl/common/utils/getStartedCookie';
import Text from '@cartwhl/ui/base/Text';

import { noticesStore } from 'stores/global';

import AuthPageLayout from './AuthPageLayout';
import SignupEmailForm from './SignupEmailForm';
import SignupGoogleForm from './SignupGoogleForm';
import SignupMethodToggle, { type SignupMethod } from './SignupMethodToggle';

const SIGNUP_REQUIRED_ERROR_CODE = 'P';

export default function SignupPage() {
  const [searchParams] = useSearchParams();
  const errorCode = searchParams.get('errorCode');
  const [signupMethod, setSignupMethod] = useState<SignupMethod>('email');
  const didNotifySignupRequired = useRef(false);

  useEffect(start, []);

  useEffect(() => {
    if (errorCode !== SIGNUP_REQUIRED_ERROR_CODE) return;

    setSignupMethod('google');

    if (didNotifySignupRequired.current) return;
    didNotifySignupRequired.current = true;
    noticesStore.error('No account found. Please sign up to continue.');
  }, [errorCode]);

  const loginParams = new URLSearchParams(searchParams);
  loginParams.delete('errorCode');
  const loginSearch = loginParams.toString();

  return (
    <AuthPageLayout title="Create account">
      <SignupMethodToggle value={signupMethod} onChange={setSignupMethod} />

      {signupMethod === 'email' ? <SignupEmailForm /> : <SignupGoogleForm />}

      <Text
        as="div"
        variant="studio/body/sm"
        className="text-gray-45 text-center"
      >
        Have an account?{' '}
        <Link
          to={loginSearch ? `/login?${loginSearch}` : '/login'}
          className="text-green-50 hover:underline"
        >
          Sign in
        </Link>
      </Text>
    </AuthPageLayout>
  );
}
